Vue.component('basic-checkbox', {
    props: ['value', 'label'],
    data: function () {
        return {
            id:  String(Math.random()).replace("0.", "")
        }
    },
    template:
`
<div>
    <div class="pm-checkbox">  
        <input v-model="value.state"  type="checkbox" v-bind:id="id" v-bind:name="id">
        <label v-bind:for="id"></label>
    </div>
    <label for="pm-checkbox" class="pm-checkbox-label">{{ label }}</label>
</div>    
`
});

Vue.component('slide-checkbox', {
    props: ['value', 'label'],
    data: function () {
        return {
            id:  String(Math.random()).replace("0.", "")
        }
    },
    template:
`
<div>
    <div class="pm-slide-checkbox">
        <input v-model="value.state" type="checkbox" v-bind:id="id" v-bind:name="id">
        <label v-bind:for="id"></label>
    </div>
    <label for="pm-slide-checkbox" class="pm-slide-checkbox-label">{{ label }}</label>
</div>    
`
});

/* global gv */

var pricelistTranslates = {
    "Available" : ["Volný"],
    "Add to favourite": ["Přidat do oblíbených"],
    "apartment": ["byt"],
    "apartments": ["typy-bytu"],
    "Apartment": ["Byt"],
    "Apartments": ["Byty"],
    "area": ["plocha"],
    "Area": ["Plocha"],
    "balcony" : ["balkon"],
    "Balcony": ["Balkon"],
    "bathroom" : ["koupelna"],
    "bathroom + toilet" : ["koupelna + wc"],
    "bedroom" : ["ložnice"],
    "beverage store" : ["sklad nápojů"],
    "bistro" : ["bistro"],
    "bistro + gallery" : ["bistro + galerie"],
    "break room staff" : ["denní místnost personál"],
    "Building": ["Budova"],
    "cleaning" : ["úklid"],
    "cloak room" : ["šatna"],
    "cloakroom": ["šatna"],
    "cloakroom men" : ["šatna muži"],
    "cloakroom women" : ["šatna ženy"],
    "commerce" : ["komerce"],
    "corridor" : ["chodba"],
    "CZK": ["Kč"],
    "dining room" : ["jídelna"],
    "Disposition": ["Dispozice"],
    "dressing room": ["šatna"],
    "dry store" : ["suchý sklad"],
    "DOWNLOAD PDF" : ["STÁHNOUT PDF"],
    "en": ["cs"],
    "ENERGY LABEL" : ["ENERGETICKÁ NÁROČNOST"],
    "Enquire": ["Poptat"],
    "Enquire apartment": ["Poptávkový formulář"],
    "Filter": ["Filtrace"],
    "First name": ["Jméno"],
    "Flat": ["Užitná"],
    "Flat area": ["Výměra bytu"],
    "Flat Area": ["Podlahová plocha"],
    "Flat Detail": ["Detail bytu"],
    "Flat No.": ["Číslo bytu"],
    "Floor": ["Podlaží"],
    "Floorplan": ["Půdorys"],
    "Filter reset" : ["Reset filtru"],
    "for satisfaction surveys": ["za účelem průzkumu spojenosti"],
    "garbage" : ["odpad"],
    "garden" : ["zahrada"],
    "home office" : ["pracovna"],
    "I consent to the processing of my": ["Souhlasím se zpracováním"],
    "I give my consent to receiving marketing materials" : ["Souhlasím se zasíláním marketingových materiálů"],
    "Incl. vat": ["Včetně DPH"],
    "insulation" : ["izolace"],
    "It is necessary to make an additional purchase of a parking space and a cellar storage room of one‘s choice with each apartment." : ["Ke každému bytu je nutné přikoupit parkovací stání a sklep dle vlastního výběru."],
    "I'm interested in an apartment n." : ["Mám zájem o byt č."],
    "Apartment handover is planned in third quarter of 2023" : ["Předání bytů majitelům je plánováno na 3Q 2023."],
    "I'm interested in an commerce n." : ["Mám zájem o komerce č."],
    "kitchen" : ["kuchyně"],
    "Last name": ["Příjmení"],
    "Layout": ["Dispozice"],
    "living room" : ["obývací pokoj"],
    "living room, kitchen" : ["obývací pokoj, kuchyně"],
    "lumber room" : ["komora"],
    "No results matching the filter" : ["Filtru neodpovídá žádná jednotka"],
    "Note: This drawing is for illustration only. The set up of interior (furniture, kitchen, el. appliance, etc.) featured in the apartment drawings is not subject of delivery. The scope of delivery is specified in the standard. All visualizations are for illustration only." : ["Upozornění: Plochy jednotlivých místností jsou pouze orientační. Vyobrazené zařízení v plánech bytů (nábytek, kuch. linka, el. spotřebiče atd.) není součástí dodávky. Rozsah dodávky je specifikován ve standardu.  Všechny vizualizace jsou pouze ilustrační"],
    "office" : ["kancelář"],
    "Orientation": ["Orientace"],
    "pantry" : ["komora"],
    "personal data": ["osobních údajů"],
    "personal-data-protection" : ["ochrana-osobnich-udaju"],
    "Phone": ["Telefonní číslo"],
    "Photo": ["Fotografie"],
    "playroom/dining room and bedroom" : ["herna/jídelna a ložnice"],
    "Please verify you are not a robot": ["Prosím zaškrtněte tlačítko: Nejsem robot"],
    "preparatory area" : ["přípravna"],
    "Pre-reserved" : ["Predrezervovaný"],
    "Price": ["Cena"],
    "Price incl. VAT": ["Cena vč. DPH"],
    "Price list": ["Ceník"],
    "Project": ["Projekt"],
    "RETAIL": ["KOMERCE"],
    "Reserved" : ["Rezervovaný"],
    "Room Name" : ["Název místnosti"],
    "R.N." : ["Č."],
    "Section": ["Sekce"],
    "Send": ["Odeslat"],
    "Show only available": ["Jen dostupné"],
    "Similar apartments": ["Podobné byty"],
    "Sold" : ["Prodaný"],
    "staircase" : ["schodiště"],
    "staff corridor" : ["chodba personál"],
    "staff room" : ["zázemí - personál"],
    "staff wc hall" : ["wc předsíň personál"],
    "STANDARDS" : ["STANDARDY"],
    "Status": ["Stav"],
    "store" : ["sklad"],
    "supply corridor" : ["zásobovací chodba"],
    "terrace" : ["terasa"],
    "Terrace": ["Terasa"],
    "toilet" :  ["wc"],
    "TOTAL AREA OF ROOMS" : ["MÍSTNOSTI CELKEM"],
    "TOTAL GROSS FLOOR AREA" : ["PODLAHOVÁ PLOCHA CELKEM"],
    "TOTAL AREA OF FLAT" : ["PLOCHA CELKEM"],
    "toy store" : ["sklad hraček"],
    "Type": ["Typ"],
    "units of" : ["jednotek z celkem"],
    "wc children" : ["wc děti"],
    "wc children disabled" : ["wc děti invalida"],
    "wc disabled" : ["wc invalida"],
    "wc men" : ["wc muži"],
    "wc men hall" : ["wc muži předsíň"],
    "wc women" : ["wc ženy"],
    "wc women hall" : ["wc ženy předsíň"],
    "wc + shower" : ["wc + sprcha"],
    "wc + shower men" : ["wc + sprcha muži"],
    "wc + shower women" : ["wc + sprcha ženy"],
    "Your message": ["Vaše zpráva"]
};

var pricelistOrientation = {
    "svz" : ["new"],
    "v" : ["e"],
    "vz" : ["ew"],
    "z" : ["w"],
    "jvz" : ["sew"],
    "sjvz" : ["nsew"],
    "jz" : ["sw"],
    "j" : ["s"],
    "sv" : ["ne"],
    "sj" : ["ns"],
    "sjv" : ["nse"],
    "s" : ["n"],
    "vj" : ["es"],
    "szj" : ["nws"]
}

Vue.mixin({
    methods: {
        $t: function (key) {
            if (typeof key === "undefined" || key === "") return "$t(key) - missing key";
            else if (!(key in pricelistTranslates) || gv.en) return key;
            else return pricelistTranslates[key][0]
        },

        $y: function (key) {
            if (typeof key === "undefined" || key === "") return "$y(key) - missing key";
            else if (!(key in pricelistOrientation) || gv.cs) return key;
            else return pricelistOrientation[key][0]
        }
    }
});

/* global gv */

var pricelistApp = new Vue({

    el: '#vue-pricelist',

    data: {
        gv: gv,
        //flatGallery: flatGallery,
        translates: pricelistTranslates,
        translatesOrientation: pricelistOrientation,
        checkedFilters: [],
        checkedFiltersType: [],
        oppositionCheckedFilters: [],
        test: [],

        urlParams: new URL(window.location.href).searchParams.get("type"),

        dataUrl: `${gv.root_url}/api/pricelist/`,
        filters: {
            price: {
                min: 0,
                max: 45000000
            },
            onlyAvailable: {
                state: true
            },
            project: {
                'marinaNova' : {
                    state: true,
                    available: false,
                    label: gv.cs ? 'Byty' : 'Apartments'
                },
                'komerce' : {
                    state: true,
                    available: false,
                    label: gv.cs ? 'Komerce' : 'Retail'
                }
            },
            floor: {
                1 : {
                    state: false,
                    available: false,
                    label: "1 NP"
                },
                2 : {
                    state: false,
                    available: false,
                    label: "2 NP"
                },
                3 : {
                    state: false,
                    available: false,
                    label: "3 NP"
                },
                4 : {
                    state: false,
                    available: false,
                    label: "4 NP"
                },
                5 : {
                    state: false,
                    available: false,
                    label: "5 NP"
                },
                6 : {
                    state: false,
                    available: false,
                    label: "6 NP"
                },
                7 : {
                    state: false,
                    available: false,
                    label: "7 NP"
                },
                8 : {
                    state: false,
                    available: false,
                    label: "8 NP"
                },
                9 : {
                    state: false,
                    available: false,
                    label: "9 NP"
                },
                10 : {
                    state: false,
                    available: false,
                    label: "10 NP"
                },
            },
            orientation: {
                "V" : {
                    state: false,
                    available: false,
                    label: "V"
                },
                "S" : {
                    state: false,
                    available: false,
                    label: "S"
                },
                "Z" : {
                    state: false,
                    available: false,
                    label: "Z"
                },
                "VJ" : {
                    state: false,
                    available: false,
                    label: "VJ"
                },
                "SV" : {
                    state: false,
                    available: false,
                    label: "SV"
                },
                "SJV" : {
                    state: false,
                    available: false,
                    label: "SJV"
                },
                "J" : {
                    state: false,
                    available: false,
                    label: "J"
                },
                "JZ" : {
                    state: false,
                    available: false,
                    label: "JZ"
                },
                "VZ" : {
                    state: false,
                    available: false,
                    label: "VZ"
                },
                "SVZ" : {
                    state: false,
                    available: false,
                    label: "SVZ"
                },
            },
            type: {
                "1": {
                    state: false,
                    available: false,
                    label: "Komfort"
                },
                "2": {
                    state: false,
                    available: false,
                    label: "Minipenthouse"
                },
                "3": {
                    state: false,
                    available: false,
                    label: "Penthouse"
                },
                "4": {
                    state: false,
                    available: false,
                    label: "Duplex"
                }
            },
            layout: {
                "1kk" : {
                    state: false,
                    available: false,
                    label: "1+kk"
                },
                "2kk" : {
                    state: false,
                    available: false,
                    label: "2+kk"
                },
                "3kk" : {
                    state: false,
                    available: false,
                    label: "3+kk"
                },
                "4kk" : {
                    state: false,
                    available: false,
                    label: "4+kk"
                },
                "5kk" : {
                    state: false,
                    available: false,
                    label: "5+kk"
                }
            },
            section: {
                "1" : {
                    state: false,
                    available: false,
                    label: "1"
                },
                "2" : {
                    state: false,
                    available: false,
                    label: "2"
                },
                "3" : {
                    state: false,
                    available: false,
                    label: "3"
                },
                "4" : {
                    state: false,
                    available: false,
                    label: "4"
                },
                "5" : {
                    state: false,
                    available: false,
                    label: "5"
                },
                "6" : {
                    state: false,
                    available: false,
                    label: "6"
                }
            }
        },
        items: [],
        filteredItems: [],
        sortByField: 'name',
        sortDirection: 1,
        enquiredItem: null,
        emptyMessage: false
    },

    methods: {

        resetFilter() {
            this.checkedFilters = [];
            this.checkedFiltersType = [];
            this.oppositionCheckedFilters = [];
            this.filters.price.min = 0;
            this.filters.price.max = 45000000;

            this.initSliderFilter();
        },

        thousandSeparator(amount) {
            return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },

        initForm(item)
        {
            this.enquiredItem = item;

            var enquireForm;

            if (gv.cs === 1) {
                enquireForm = new FormController($(document).find("#enquire-form"), {
                    constraints: {
                        "cntnt01fbrp__1": {presence: {message: "Pole 'Jméno' je povinné"}},
                        "cntnt01fbrp__2": {presence: {message: "Pole 'Příjmení' je povinné"}},
                        "cntnt01fbrp__4": {presence: {message: "Pole 'telefon' je povinné"}},
                        "cntnt01fbrp__5": {presence: {message: "Pole 'Zpráva' je povinné"}},
                        "cntnt01fbrp__3": {
                            presence: {message: "Pole 'Email' je povinné"},
                            email: {message: "E-mail je neplatný"},
                        },
                    },
                    recaptchaSelector: '#contact-form-recaptcha'
                });
            } else {
                enquireForm = new FormController($(document).find("#enquire-form"), {
                    constraints: {
                        "cntnt01fbrp__1": {presence: {message: "First name field is required"}},
                        "cntnt01fbrp__2": {presence: {message: "Last name field is required"}},
                        "cntnt01fbrp__4": {presence: {message: "Phone field is required"}},
                        "cntnt01fbrp__5": {presence: {message: "Your message is empty"}},
                        "cntnt01fbrp__3": {
                            presence: {message: "E-mail field is required"},
                            email: {message: "E-mail is invalid"},
                        },
                    },
                    recaptchaSelector: '#contact-form-recaptcha'
                });
            }
        },

        sortBy(field, event)
        {
            this.sortDirection *= -1;
            this.sortByField = field;

            this.filteredItems = this.filteredItems.sort((a,b) => {

                if (a[field] > b[field]) {
                    $("th").removeClass("asc desc");
                    if (event) $(event.path[0]).addClass("asc");
                    return 1*this.sortDirection;
                }

                if (a[field] < b[field]) {
                    $("th").removeClass("asc desc");
                    if (event) $(event.path[0]).addClass("desc");
                    return -1*this.sortDirection;
                }
                return 0;
            });
        },

        initSliderFilter()
        {
            let $rangeSlider = $( ".slider-range" );
            $rangeSlider.slider({
                range: true,
                min: this.filters.price.min,
                max: this.filters.price.max,
                step: 500000,
                values: [ this.filters.price.min, this.filters.price.max ],
                slide: ( event, ui ) => {
                    this.filters.price.min = ui.values[ 0 ];
                    this.filters.price.max = ui.values[ 1 ];
                    this.applyFilters();
                }
            });
        },

        isAnyFilterActive(obj)
        {
            let result = false;
            for (let filter in obj) {
                if (obj.hasOwnProperty(filter)) {
                    if (obj[filter].state) result = true;
                }
            }
            return result
        },

        applyFilters()
        {
            let filteredItems = JSON.parse(JSON.stringify(this.items));

            let applyBuildingFilter = this.isAnyFilterActive(this.filters.building);
            let applyFloorFilter = this.isAnyFilterActive(this.filters.floor);
            let applyLayoutFilter = this.isAnyFilterActive(this.filters.layout);

            filteredItems = filteredItems.filter((item) => {

                if (this.filters.onlyAvailable.state && item.status !== 0 && item.status !== 2) return false;
                if (item.price < this.filters.price.min) return false;
                if (item.price > this.filters.price.max) return false;

                if (!this.filters.project[item.project].state) {
                    if (item.type !== 5) return false;
                };

                if (!this.filters.project["komerce"].state) {
                    if (item.type === 5) return false;
                }

                //if (applyBuildingFilter && !this.filters.building[item.building].state) return false;
                //if (applyFloorFilter && !this.filters.floor[item.floor].state) return false;
                //if (applyLayoutFilter && !this.filters.layout[item.layout].state) return false;

                return true;
            });

            this.filteredItems = filteredItems;
        },

        setAvailableFilters()
        {
            let minPrice = 0;
            let maxPrice = 0;

            this.items.forEach((item) => {

            })
        },

        setItems(items)
        {
            this.items = items;
            this.setAvailableFilters();
            this.applyFilters();
            this.sortBy(this.sortByField);
        },

        getItems()
        {
            this.$http.get(this.dataUrl).then(response => {
                this.setItems(response.body.pricelist);
            }, response => {
                console.log('getData: Error', response.status);
            });
        },
        rowDetail(url, status)
        {
            console.log("row clickable url: ", url, status);

            if (status !== 3) {
                window.location.href = gv.root_url + url;
            }

        },
        getFlatGalleryItems(alias) {

            return flatGallery[alias];

        },

        showLightGallery(apartmentNumber){           

            DynamicGallery.init($('#gallery-flat-' + apartmentNumber));

        },
    },

    filters: {
        priceRangeFormat: function (value) {
            return parseFloat(value / 1000000);
        }
    },

    watch: {
        filters: {
            handler: function() {
                this.applyFilters();
            },
            deep: true
        }
    },

    computed: {
        /**
         * Funkce, která po interakci s filtrem, projde object filteredItems a vrátí dostupné vyfiltrované položky.
         * @returns {Array}
         */
        filteredTable() {

            if (this.checkedFilters.length === 0 && this.checkedFiltersType === 0 && this.oppositionCheckedFilters.length === 0) return this.filteredItems;
            let dataCollector = this.filteredItems;

            dataCollector.filter(item => {
                if (this.checkedFiltersType.find(element => element === item.type.toString()) && this.checkedFiltersType.find(element => element === item.type.toString()) !== "undefined") {
                    dataCollector= dataCollector.filter(item => {
                        if (this.checkedFiltersType.find(element => element === item.type.toString())) {
                            return item;
                        }
                    });
                } else {
                    dataCollector = dataCollector;
                }

                if (this.checkedFilters.find(element => element === item.floor.toString()) && this.checkedFilters.find(element => element === item.floor.toString()) !== "undefined") {
                    dataCollector= dataCollector.filter(item => {
                        if (this.checkedFilters.find(element => element === item.floor.toString())) {
                            return item;
                        }
                    });
                } else {
                    dataCollector = dataCollector;
                }

                if (this.checkedFilters.find(element => element === item.layout.toString()) && this.checkedFilters.find(element => element === item.layout.toString()) !== "undefined") {
                    dataCollector= dataCollector.filter(item => {
                        if (this.checkedFilters.find(element => element === item.layout.toString())) {
                            return item;
                        }
                    });
                } else {
                    dataCollector = dataCollector;
                }

                if (this.oppositionCheckedFilters.find(element => element === item.section.toString()) && this.oppositionCheckedFilters.find(element => element === item.section.toString()) !== "undefined") {
                    dataCollector= dataCollector.filter(item => {
                        if (this.oppositionCheckedFilters.find(element => element === item.section.toString())) {
                            return item;
                        }
                    });
                } else {
                    dataCollector = dataCollector;
                }
            });

            return dataCollector.map(item => item);
        }
    },

    updated() {
      if (this.filteredTable.length === 0) this.emptyMessage = true;
      else this.emptyMessage = false;
    },

    mounted() {
        this.getItems();
        this.initSliderFilter();
        $(".defaultCheck").prop('checked', true);

        setTimeout(function(){
            $("#default-sort").trigger("click");
        }, 300);

        if (this.urlParams !== null) {
            this.checkedFiltersType.push(this.urlParams);
        }
    },

    template:
`
<div>    
    <div class="container mt-5">
        <div class="row">
            <div class="col">
                <h3>
                    {{ $t("Filter") }} 
                    <a href="#" class="collapse-filter" data-toggle="collapse" href="#collapseFilter" role="button" aria-expanded="false" aria-controls="collapseFilter">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px"><g data-name="Layer 2"><g data-name="arrow-ios-upward"><rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"/><path fill="#636667" d="M18 15a1 1 0 0 1-.64-.23L12 10.29l-5.37 4.32a1 1 0 0 1-1.41-.15 1 1 0 0 1 .15-1.41l6-4.83a1 1 0 0 1 1.27 0l6 5a1 1 0 0 1 .13 1.41A1 1 0 0 1 18 15z"/></g></g></svg>
                    </a>
                </h3>
            </div>
                        
            <div class="col-auto ml-auto"><h3>{{filteredTable.length}} {{ $t("units of") }} {{items.length}}</h3></div>
        </div>
    </div>
    
    <div class="collapse show" id="collapseFilter">
        <div class="container">
            <div class="row">
             
                <div v-for="filter in filters.project" class="col-auto mt-3">
                    <slide-checkbox :value="filter" :label="$t(filter.label)"></slide-checkbox>
                </div>
                
                <div class="ml-lg-auto col-auto mt-0 pl-3 pl-sm-3 mt-3"> 
                    <slide-checkbox :value="filters.onlyAvailable" :label="$t('Show only available')"></slide-checkbox>
                </div>
                
            </div>
        </div>
         
        <div class="container mt-4 pb-5 mt-lg-3" id="pricelist-filtration">
            <div class="row plf-row">
                <div class="col-12 col-md-3 col-lg-2 mb-2 mb-lg-0">
                    <span class="text-uppercase"> {{ $t("Type") }} </span>
                </div>
                <div v-for="(filter, index) in filters.type" class="pl-3 type-lowercase">
                    <div class="pm-checkbox">  
                        <input type="checkbox" v-model="checkedFiltersType" :id="'type' + index" :value="index">
                        <label :for="'type' + index"></label>
                    </div>
                    <label for="pm-checkbox" class="pm-checkbox-label">{{ filter.label }}</label>
                </div>
            </div>
            <div class="row plf-row mt-3">
                <div class="col-12 col-md-3 col-lg-2 mb-2 mb-lg-0">
                    <span class="text-uppercase"> {{ $t("Section") }} </span>
                </div>
                <div v-for="(filter, index) in filters.section" class="col-auto pl-3 type-lowercase">
                    <div class="pm-checkbox">  
                        <input type="checkbox" v-model="oppositionCheckedFilters" :id="'section' + index" :value="index">
                        <label :for="'section' + index"></label>
                    </div>
                    <label for="pm-checkbox" class="pm-checkbox-label">{{ filter.label }}</label>
                </div>
            </div>
            <div class="row plf-row mt-1">
                <div class="col-12 col-md-3 col-lg-2 mb-2 mt-3 mt-lg-0 mb-lg-0">
                    <span class="text-uppercase"> {{ $t("Floor") }} </span>
                </div>
                    <div v-for="(filter, index) in filters.floor" class="col-auto pl-3">
                        <div class="pm-checkbox">  
                            <input type="checkbox" v-model="checkedFilters" :id="index" :value="index">
                            <label :for="index"></label>
                        </div>
                        <label for="pm-checkbox" class="pm-checkbox-label">{{ filter.label }}</label>
                    </div>
            </div>
            <div class="row plf-row mt-1">
                <div class="col-12 col-md-3 col-lg-2 mb-2 mt-3 mt-lg-0 mb-lg-0">
                    <span class="text-uppercase"> {{ $t("Disposition") }} </span>
                </div>
                <div v-for="(filter, index) in filters.layout" class="col-auto pl-3">
                    <div class="pm-checkbox">  
                        <input type="checkbox" v-model="checkedFilters" :id="index" :value="filter.label">
                        <label :for="index"></label>
                    </div>
                    <label for="pm-checkbox" class="pm-checkbox-label">{{ filter.label }}</label>
                </div>
            </div>
             
            <div class="row align-items-center pt-1 mt-lg-0">
                <div class="col-12 col-md-3 col-lg-2 mb-2 mt-3 mt-lg-0 mb-lg-0">
                    <span class="text-uppercase"> {{ $t("Price") }} </span>
                </div>
                <div class="col-auto pl-3">
                    <span>{{filters.price.min | priceRangeFormat}}</span>
                    <input v-model="filters.price.min" type="text" class="slider-range-values d-none" readonly/>
                    <span> mil. {{ $t("CZK") }}</span>
                    <span>&lt; </span>
                </div>
                <div class="col-4">
                    <div class="slider-range"></div>
                </div>
                <div class="col-auto">
                    <span>&gt;</span>
                    <span>{{filters.price.max | priceRangeFormat}}</span>
                    <input v-model="filters.price.max" type="text" class="slider-range-values d-none" readonly/>
                    <span> mil. {{ $t("CZK") }}</span>
                </div>
            </div>
            
            <div class="row pt-4 mt-lg-0">
                <div class="col pl-3">
                    <button v-on:click="resetFilter()" class="btn btn-main">{{ $t("Filter reset") }}</button>
                </div>
            </div>
            
        </div>
    </div>
    <div class="container">
         <table class="mt-5 mt-lg-3 w-100" id="pricelist-table">
            <thead id="pricelist-table-head">
                <tr>
                    <th v-on:click="sortBy('building', $event)" class="d-none d-lg-table-cell">{{ $t("Project") }}</th>
                    <th v-on:click="sortBy('type', $event)" class="d-none d-lg-table-cell">{{ $t("Type") }}</th>
                    <th v-on:click="sortBy('name', $event)" class="desc" id="default-sort">{{ $t("Flat No.") }}</th>
                    <th v-on:click="sortBy('section', $event)" class="d-none d-lg-table-cell">{{ $t("Section") }}</th>
                    <th v-on:click="sortBy('floor', $event)" class="">{{ $t("Floor") }}</th>
                    <th v-on:click="sortBy('orientation', $event)" class="d-none d-lg-table-cell">{{ $t("Orientation") }}</th>
                    <th v-on:click="sortBy('layout', $event)" class="">{{ $t("Layout") }}</th>
                    <th v-on:click="sortBy('area', $event)" class="" width="175">{{ $t("Flat Area") }} (m²)</th>
                    <th v-on:click="sortBy('areaTerraceBalconySum', $event)" class="d-none d-lg-table-cell" style="width: 6%;">{{ $t("Terrace") }} / {{ $t("Balcony") }} (m²)</th>
                    <th v-on:click="sortBy('price', $event)" class="">{{ $t("Price incl. VAT") }}</th>
                    <th class="filter-disabled d-none d-lg-table-cell">{{ $t("Status") }}</th>
                    <th class="filter-disabled">{{ $t("Flat Detail") }}</th>
                    <!--<th class="filter-disabled">{{ $t("Photo") }}</th>-->
                    <th class="filter-disabled d-none d-lg-table-cell">{{ $t("Enquire") }}</th>            
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in filteredTable" class="pricelist-table-row"> 
                    <td class="px-0 d-none d-lg-table-cell" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">{{item.building}}</td>
                    <td class="px-0 d-none d-lg-table-cell" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">
                        <span v-if="item.type === 1">Komfort</span>
                        <span v-if="item.type === 2">Minipenthouse</span>
                        <span v-if="item.type === 3">Penthouse</span>
                        <span v-if="item.type === 4">Duplex</span>
                        <span v-if="item.type === 5">Komerce</span>
                    </td>
                    <td class="px-0" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">{{item.name}}</td>
                    <td class="px-0 d-none d-lg-table-cell" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">
                        <span v-if="item.section === 'KOMERCE'">-</span>
                        <span v-else>{{item.section}}<span>
                    </td>
                    <td class="px-0" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">{{item.floor}}</td>
                    <td class="px-0 d-none d-lg-table-cell" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">{{ $y(item.orientation) }}</td>
                    <td class="px-0" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">
                        <span v-if="item.layout === 'komerce'">-</span>
                        <span class="layout-uppercase" v-else>{{item.layout}}</span>
                    </td>
                    <td class="px-0" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">{{item.area}}</td>
                    <td class="px-0 d-none d-lg-table-cell">{{item.areaTerraceBalconySum.toFixed(2)}}</td> 
                    <td class="px-0" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">
                        <span v-if="item.status !== 3 && item.status !== 1">
                            {{thousandSeparator(item.price)}}
                        </span>
                    </td>
                    <td class="px-0 d-none d-lg-table-cell" v-on:click="rowDetail('/' + $t('apartment')  + '/' + item.alias, item.status)">
                        <span v-if="item.status === 0">{{ $t("Available") }}</span>
                        <span v-if="item.status === 1">{{ $t("Reserved") }}</span>
                        <span v-if="item.status === 2">{{ $t("Pre-reserved") }}</span>
                        <span v-if="item.status === 3">{{ $t("Sold") }}</span>
                    </td>
                    <td class="px-0">
                        <a :href="'/' + $t('apartment')  + '/' + item.alias" v-if="item.status !== 3"><i class="fas fa-search"></i></a>  
                    </td>
                    <!--
                    <td class="px-0">                    
                        <a href="#" @click.prevent="() => showLightGallery(item.alias)" v-if="item.status !== 3 && getFlatGalleryItems(item.alias)"> 
                            <i class="fa-solid fa-camera"></i>
                            <div :id='"gallery-flat-"+item.alias'>
                                <div v-for="image in getFlatGalleryItems(item.alias)" 
                                    class="d-none"
                                    :data-src="gv.content_url + image">
                                </div>
                            </div>
                        </a> 
                    </td>
                    -->
                    <td class="d-none d-lg-table-cell px-0">
                        <a href="#" data-toggle="modal" v-if="item.status !== 3" data-target="#pricelistModal" v-on:click="initForm(item);">
                            <i class="far fa-envelope"></i>
                        </a>
                    </td>       
                </tr>
            </tbody>
        </table>
        <div class="emptyMessage text-center mt-2" v-if="emptyMessage">
            <p>{{$t("No results matching the filter")}}</p>
        </div>    
    </div>
    
    
    <div class="modal fade" id="pricelistModal" tabindex="-1" role="dialog" aria-labelledby="pricelistModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content pt-3 pb-5 px-4">
            <div class="float-right">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">✖</span>
                </button>            
            </div>
              <div class="modal-body">
                <h1>{{$t('Enquire apartment')}}</h1>
                <form id="enquire-form" class="pm-form">
                    <input type="hidden" name="cntnt01fbrp__26" value="enquiry">
                    <input type="hidden" name="cntnt01fbrp__27" :value="enquiredItem ? enquiredItem.name : ''">
                    <input type="hidden" name="cntnt01fbrp__28" :value="enquiredItem ? enquiredItem.projectId : ''">
                    <div class="row m-0">
                        <div class="col-12 col-lg-6 pl-0 pr-0 pr-md-3">
                            <div class="form-group h-100 px-0">
                                <textarea name="cntnt01fbrp__5" id="contact-message" class="form-control h-100">{{$t("I'm interested in an apartment n.")}} {{enquiredItem ? enquiredItem.name : ''}}</textarea>
                            </div>
                        </div> 
                        <div class="col-12 col-lg-6 px-0 mt-2 mt-md-0">
                            <div class="row">
                                <div class="form-group col-6 mb-2">
                                    <input type="text" class="form-control" id="contact-name" name="cntnt01fbrp__1" :placeholder="$t('First name')" autocomplete="given-name">
                                </div>
                                <div class="form-group col-6 pl-1 mb-2">
                                    <input type="text" class="form-control" id="contact-surname" name="cntnt01fbrp__2" :placeholder="$t('Last name')" autocomplete="family-name">
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="form-group col-12 mb-2">
                                    <input type="email" class="form-control" id="contact-email" name="cntnt01fbrp__3" placeholder="E-mail" autocomplete="email">
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="form-group col-12 mb-2 mb-md-0">
                                    <input type="text" class="form-control" id="contact-phone" name="cntnt01fbrp__4" :placeholder="$t('Phone')" autocomplete="tel"> 
                                </div>
                            </div>
                            
                            <div class="row d-none">
                                <div class="form-group col-12 mb-2 mb-md-0">
                                    <input type="text" class="form-control" id="contact-lang" name="cntnt01fbrp__16" :value="$t('en')" autocomplete="lang">
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 col-lg-6 pl-0 mt-3">
                            <div class="custom-control custom-checkbox checkbox-circle custom-control-inline d-block mt-2">
                                <input type="checkbox" id="marketing" class="custom-control-input" name="cntnt01fbrp__17" autocomplete="marketing"> 
                                <label for="marketing" class="custom-control-label"><small>{{ $t("I give my consent to receiving marketing materials") }}.</small></label>
                            </div>
                            <div class="custom-control personal-data-control custom-checkbox checkbox-circle custom-control-inline d-block mt-2">
                                <input type="checkbox" class="custom-control-input"  name="cntnt01fbrp__18" id="contact-personal-data" autocomplete="personal-data"> 
                                <label for="contact-personal-data" class="custom-control-label"><small> {{$t("I consent to the processing of my")}} <a :href="'/' + $t('personal-data-protection')" target="_blank">{{ $t("personal data")}}</a> {{$t("for satisfaction surveys")}}.</small></label>
                            </div>
                        </div>
                        <div class="col-12 col-lg-6 px-0 mt-3">
                             <div class="row">
                                <div class="col-12 col-md text-left mt-2 pl-2">
                                    <a href="tel:800226223" class="text-nowrap">
                                        <span class="icon-circle icon-circle-sm mx-2">
                                            <i class="fas fa-phone"></i>
                                        </span>
                                        <span class="form-large-text">800 226 223</span>
                                    </a>
                                </div>
                                <div class="form-group col-12 col-md text-right mt-2">
                                    <button class="btn btn-main text-uppercase">{{$t('Send')}}</button>
                                </div>
                             </div>
                        </div>  
                         <div class="col-12 mt-2">
                            <div class="row">
                                <div class="form-group col-12 col-md collapse pl-0 mt-3" id="contact-form-recaptcha">
                                    <div class="g-recaptcha" data-sitekey="6LeBvHQUAAAAAP0kp4GX8bMARWHDmlV8UDzxsljk"></div>
                                    <div class="g-recaptcha-error-box text-danger" style="display: none;"><i class="fa fa-exclamation-triangle"></i> $t('Please verify you are not a robot').</div>
                                </div>
                            </div>
                        </div>                      
                    </div>
                </form>
              </div>
        </div>
      </div>
    </div>
    
    
</div>  

`
});
